var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-meta-field"},[(_vm.showIcon)?_c('icon',{staticClass:"icon",attrs:{"width":"18","height":"18","name":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }